import {inject, Injectable} from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import {environment} from "../../environments/environment.development";
import {catchError, Observable, throwError} from "rxjs";
import {AppMetaData} from "../shared/interfaces/user";

export interface ReportDetails {
  id: string,
  incidentId: string,
  productionLine: string,
  productionLineName: string,
  workplace: string,
  category: string,
  created_at: string,
  message: string,
  link: string
}

export interface NotificationRequest {
  targetRole: string;
  reportDetails: ReportDetails;
}

export interface NotificationResponse {
  done: boolean;
  recipientCount: number;
  recipients: {
    id: string,
    email: string,
    raw_app_meta_data: AppMetaData
  }[]
}

@Injectable({
  providedIn: 'root'
})
export class LocalSupabaseEdgeFunctionService {
  http = inject(HttpClient)

  private readonly sendEmailUrl: string = `${environment.supabaseEdgeFunctionEndpoint}/send-email`;
  private readonly headers = {
    'Authorization': `Bearer ${environment.supabaseKey}`,
    'Content-Type': 'application/json'
  }

  /**
   * Sends a notification about a stillstand to specified user role
   * @param targetRole - The role of users who should receive the notification
   * @param reportDetails - Details about the report
   * @returns Observable of type notification response
   */
  sendEscalationEmail(targetRole: string, reportDetails: ReportDetails): Observable<NotificationResponse> {
    const payload: NotificationRequest = {
      targetRole,
      reportDetails
    }

    return this.http.post<NotificationResponse>(
      this.sendEmailUrl,
      payload,
      {headers: this.headers}
    ).pipe(
      catchError(this.handleError)
    )

  }

  /**
   * Handles HTTP errors
   * @param error - The HTTP error response
   * @returns An observable with the error message
   */
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Ein Fehler ist aufgetreten.';

    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Fehler: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Fehlercode: ${error.status}\nNachricht: ${error.message}`;
    }

    console.error('Stillstand Notification Error:', error);
    return throwError(() => errorMessage);
  }
}
